import MainPage from "./components/MainPage";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <div className=" min-h-screen">
      <MainPage />
      <ToastContainer />
    </div>
  );
}

export default App;
